module.exports = __webpack_public_path__ + "static/media/landelijk.9fc8f797.jpg";